
    import { mapActions } from 'vuex'
    import MediaViewer from "./MediaViewer.vue"
    import PublicationFilesMixin from "../channels/PublicationFilesMixin"
    import {AJAX, DLP} from '../../store/modulesNames'
    import {ACT_AJAX_GET_FILE, ACT_SEND_FILE_SAVE_EVENT} from '../../store/actionsTypes'
    import {DLP_SOURCE_TYPES} from '../../store/modules/dlp'
    import {CONTACT_FIELD_TYPES} from '../../constants'

    export default {
        name: "PublicationMediaViewer",
        extends: MediaViewer,
        props: {
            chId: {
                type: Number,
                required: true
            },
            pubId: {
                type: Number,
                required: true
            },
            index: {
                type: Number,
                required: true
            }
        },
        mixins: [PublicationFilesMixin],
        created() {
            this.currImgIndex = this.index
            this.loadMessageFile()
        },
        computed: {
            user() {
                if (!this.publication) return 
                if (this.publication.cid) {
                    let result = this.$store.getters['contacts/getMergedContactById'](this.publication.cid);
                    return {'photo': result[CONTACT_FIELD_TYPES.PHOTO], 'fio': result.fio};
                } else {
                    let channel = this.$store.getters['channels/getChannel']({chId: this.publication.chId});
                    let photo = app.getChannelPhotoUrl(channel.icon);
                    return {'photo': photo, 'fio': channel.name};
                }
            },
            file() {
                return this.mediaItem && this.mediaItem.file
            },
            path() {
                let file = this.link
                if(file) {
                    this.preload = false;
                    return file;
                }
            },
            preview() {
                return this.getPreview(this.mediaItem)
            },
            time() {
                let time = this.publication.time;
                return this.getTimeFromSecondsLeft(time)
            },
            extension() {
                return this.mediaItem.extension
            },
            publication() {
                return this.$store.getters['channel/getPublicationById']({pubId: this.pubId});
            },
            mediaItems() {
                return this.$store.getters['channel/getPublicationPreparedDataItems']({pubId: this.pubId}).with_imgs
            },
            subtitle() {
                if (this.publication) return this.publication.info
            }
        },
        methods: {
            download() {
                if (this.preload) return
                let a = document.createElement('a');
                a.setAttribute('href', this.path);
                a.setAttribute('target', '_blank');
                a.setAttribute('download', this.getDownloadFileName(this.mediaType, null, this.extension))
                a.click();
            },
            async loadMessageFile() {
                if (!this.mediaItem) return
                try {
                    let blob_url = this.link
                    if (blob_url) {
                        this.preload = false
                        return;
                    }
                    await this[ACT_AJAX_GET_FILE]({url: this.mediaItem.file, fileSize: this.mediaItem.size, link: true})
                    this.preload = false
                } catch (e) {
                    console.log("🚀 ~ PublicationMediaViewer.vue:94 ~ loadMessageFile ~ e:", e)
                }
            },
            onMediaItemChange() {
                this.loadMessageFile()
            },
            onItemSaved() {
                this.$store.dispatch(`${DLP}/${ACT_SEND_FILE_SAVE_EVENT}`, {
                    fileName:  this.mediaItem.file,
                    sourceType: DLP_SOURCE_TYPES.PUBLICATION,
                    sourceData: {
                        chId: this.publication.chId,
                        pubId: this.pubId,
                    }
                })
            },
            ...mapActions(AJAX, [ACT_AJAX_GET_FILE])
        },

    }
